let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6VGr2")).then(() => parcelRequire('kwQYh'));